// resources/js/__Data/apparel.js
export const apparelPage = {
  seo: {
    title: "Apparel - Captex",
    description: "Explore Captex apparel.",
    keywords: "apparel, captex",
  },
  hero: {
    eyebrow: "Apparel Collection",
    title: "Apparel",
    subtitle: "Premium apparel to complement the cap range.",
    description: "Premium apparel to complement the cap range.",
    image: "https://images.unsplash.com/photo-1529139574466-a303027c1d8b?auto=format&fit=crop&w=1800&q=90",
    imageAlt: "Captex premium apparel collection",
    primaryAction: {
      label: "Shop Now",
      href: "/shop",
    },
    secondaryAction: {
      label: "View Collections",
      href: "/collections",
    },
  },
  story: {
    eyebrow: "Our Story",
    title: "Story",
    subtitle: "A simple apparel story with modern utility.",
    description: "A simple apparel story with modern utility.",
    secondaryText: "Crafted with precision and care for the modern individual.",
    image: "https://images.unsplash.com/photo-1529139574466-a303027c1d8b?auto=format&fit=crop&w=800&q=80",
    imageAlt: "Captex apparel story",
    values: [
      "Premium Quality Materials",  // ✅ Fixed duplicates
      "Timeless Design",
      "Perfect Fit Guarantee",
      "Sustainable Production",
    ],
    buttonLabel: "Learn More",
    buttonHref: "/about",
  },
  highlight: {
    eyebrow: "Featured",
    title: "Highlight",
    subtitle: "Refined essentials for everyday wear.",
    description: "Refined essentials for everyday wear.",
    quote: "Refined essentials for everyday wear.",
    author: "Captex",
    image: "https://images.unsplash.com/photo-1529139574466-a303027c1d8b?auto=format&fit=crop&w=1200&q=80",
    imageAlt: "Captex apparel highlight",
    buttonLabel: "Explore",
    buttonHref: "/collections",
  },
  featuredProducts: [],
  banner: {
    eyebrow: "Limited Edition",
    title: "Apparel Banner",
    subtitle: "Discover our latest collection",
    description: "Premium apparel for the modern individual.",
    image: "https://images.unsplash.com/photo-1529139574466-a303027c1d8b?auto=format&fit=crop&w=1200&q=80",
    imageAlt: "Captex apparel banner",
    action: {
      label: "Shop Now",
      href: "/shop",
    },
  },
  gallery: {
    title: "Lifestyle Gallery",
    images: [
      "https://images.unsplash.com/photo-1529139574466-a303027c1d8b?auto=format&fit=crop&w=600&q=80",
      "https://images.unsplash.com/photo-1529139574466-a303027c1d8b?auto=format&fit=crop&w=600&q=80",
      "https://images.unsplash.com/photo-1529139574466-a303027c1d8b?auto=format&fit=crop&w=600&q=80",
    ],
  },
  features: [
    {
      id: 1,
      icon: "Shirt",
      title: "Premium Quality",
      description: "Made from the finest materials for lasting comfort.",
    },
    {
      id: 2,
      icon: "Clock",
      title: "Timeless Design",
      description: "Classic styles that never go out of fashion.",
    },
    {
      id: 3,
      icon: "Ruler",
      title: "Perfect Fit",
      description: "Designed to fit perfectly for every body type.",
    },
    {
      id: 4,
      icon: "Leaf",
      title: "Sustainable",
      description: "Eco-friendly materials and ethical production.",
    },
  ],
  categories: [
    {
      id: 1,
      name: "T-Shirts",
      title: "T-Shirts",
      image: "https://images.unsplash.com/photo-1529139574466-a303027c1d8b?auto=format&fit=crop&w=400&q=80",
      href: "/collections/tshirts",
      productCount: 24,
      description: "24 products",
    },
    {
      id: 2,
      name: "Hoodies",
      title: "Hoodies",
      image: "https://images.unsplash.com/photo-1529139574466-a303027c1d8b?auto=format&fit=crop&w=400&q=80",
      href: "/collections/hoodies",
      productCount: 18,
      description: "18 products",
    },
    {
      id: 3,
      name: "Jackets",
      title: "Jackets",
      image: "https://images.unsplash.com/photo-1529139574466-a303027c1d8b?auto=format&fit=crop&w=400&q=80",
      href: "/collections/jackets",
      productCount: 12,
      description: "12 products",
    },
  ],
  statistics: [
    {
      id: 1,
      label: "Happy Customers",
      value: "15000",  // ✅ Keep as string for consistent rendering
      suffix: "+",
    },
    {
      id: 2,
      label: "Products Sold",
      value: "45000",
      suffix: "+",
    },
    {
      id: 3,
      label: "Years Experience",
      value: "5",
    },
    {
      id: 4,
      label: "Global Reach",
      value: "25",
      suffix: "+ Countries",
    },
  ],
  testimonials: [
    {
      id: 1,
      customerName: "Sarah Johnson",
      country: "USA",
      rating: 5,
      review: "The quality of the apparel is outstanding. The fabric feels premium and the fit is perfect. I've already ordered three more pieces!",
      date: "January 15, 2024",
      verifiedPurchase: true,
      category: "Apparel",
      purchasedProduct: "Premium T-Shirt",
      title: "Exceptional Quality",
    },
    {
      id: 2,
      customerName: "Michael Chen",
      country: "Canada",
      rating: 5,
      review: "This is my go-to brand for everyday wear. The attention to detail and comfort level is unmatched. Highly recommended!",
      date: "January 12, 2024",
      verifiedPurchase: true,
      category: "Apparel",
      purchasedProduct: "Classic Hoodie",
      title: "Perfect Everyday Wear",
    },
    {
      id: 3,
      customerName: "Emily Rodriguez",
      country: "UK",
      rating: 4,
      review: "Great quality and fast shipping. The hoodie I ordered exceeded my expectations. Will definitely be a returning customer.",
      date: "January 10, 2024",
      verifiedPurchase: false,
      category: "Apparel",
      purchasedProduct: "Lightweight Jacket",
      title: "Great Value",
    },
    {
      id: 4,
      customerName: "David Kim",
      country: "Australia",
      rating: 5,
      review: "The best apparel I've purchased in years. The materials are premium and the designs are timeless. Absolutely love it!",
      date: "January 8, 2024",
      verifiedPurchase: true,
      category: "Apparel",
      purchasedProduct: "Signature Sweater",
      title: "Premium Quality",
    },
  ],
  callToAction: {
    eyebrow: "Ready to upgrade?",
    title: "Shop Apparel",
    subtitle: "Discover premium apparel that combines style with comfort.",
    description: "Discover premium apparel that combines style with comfort.",
    href: "/shop",
    label: "Shop Now",
    image: "https://images.unsplash.com/photo-1529139574466-a303027c1d8b?auto=format&fit=crop&w=1200&q=80",
    primaryAction: {
      label: "Shop Now",
      href: "/shop",
    },
    secondaryAction: {
      label: "Learn More",
      href: "/about",
    },
  },
};